import api from './api';

const teacherService = {
    // Get current teacher profile
    getMyProfile: async () => {
        const response = await api.get('/teachers/me');
        return response.data;
    },

    // Get teacher stats
    getStats: async () => {
        const response = await api.get('/teachers/me/stats');
        return response.data;
    },

    // Get student progress details (lesson-level, legacy)
    getStudentProgress: async (studentId) => {
        const response = await api.get(`/teachers/me/students/${studentId}/progress`);
        return response.data;
    },

    // Get assigned students
    getMyStudents: async (params = {}) => {
        const response = await api.get('/teachers/me/students', { params });
        return response.data;
    },

    // Assign student (if needed self-assign)
    assignStudent: async (studentId, teacherId) => {
        const response = await api.post('/teachers/assign-student', {
            student_id: studentId,
            teacher_id: teacherId
        });
        return response.data;
    },

    // ==========================================
    // New Analytics Methods
    // ==========================================

    // Get detailed activity log for a student (question-level)
    getStudentActivity: async (studentId, params = {}) => {
        const response = await api.get(`/teachers/me/students/${studentId}/activity`, { params });
        return response.data;
    },

    // Get question answer history for a student
    getStudentQuestionHistory: async (studentId, params = {}) => {
        const response = await api.get(`/teachers/me/students/${studentId}/question-history`, { params });
        return response.data;
    },

    // Get per-lesson analytics for a student in a course
    getStudentLessonAnalytics: async (studentId, courseTitle) => {
        const response = await api.get(`/teachers/me/students/${studentId}/lesson-analytics`, {
            params: { course_title: courseTitle }
        });
        return response.data;
    },

    // Get course overview for all assigned students
    getCourseOverview: async (courseTitle, days = 7) => {
        const response = await api.get(`/teachers/me/course/${encodeURIComponent(courseTitle)}/overview`, {
            params: { days }
        });
        return response.data;
    },

    // Get session details
    getSessionDetail: async (sessionId) => {
        const response = await api.get(`/teachers/me/session/${sessionId}`);
        return response.data;
    }
};

export default teacherService;

